import { getFormNames, destroy } from 'redux-form';

const destroyAllForms = () => (dispatch, getState) => {
	const names = getFormNames()(getState());
	dispatch(destroy(...names));
};

export default destroyAllForms;
